"use client"

import { observer } from "mobx-react-lite"

import { Button } from "@/components/button"
import { ConnectMenu } from "@/components/connect-menu"
import { ConnectMenuContent } from "@/components/connect-menu-content"
import { useWalletMenuStore } from "@/domains/wallet/use-wallet-menu-store"
import useResponsive from "@/hooks/use-responsive"

export const ConnectButton = observer(() => {
  const walletMenuStore = useWalletMenuStore()
  const { preferMobileNav } = useResponsive()

  if (!walletMenuStore) {
    return null
  }

  const IconComponent = walletMenuStore.currentIcon

  return (
    <>
      <Button
        onClick={() => walletMenuStore.openMenu()}
        variant={walletMenuStore.buttonVariant}
        className="text-sm"
        size="sm"
        data-testid="connect-button"
      >
        {IconComponent && <IconComponent className={preferMobileNav ? "h-5 w-5" : "h-4 w-4"} />}
        {!preferMobileNav && walletMenuStore.displayText}
      </Button>

      <ConnectMenu
        isOpen={walletMenuStore.isMenuOpen}
        onOpenChange={(open) => (open ? walletMenuStore.openMenu() : walletMenuStore.closeMenu())}
      >
        <ConnectMenuContent onClose={() => walletMenuStore.closeMenu()} />
      </ConnectMenu>
    </>
  )
})
